<!--ExperienceTabItemWhite: 白色背景tab项目 2020/08/26 14:47:37 Sunanguang-->

<template>
   <div class="its-product-advantage" :class="item.type">
     <div class="its-calc-container">
        <class-title class="its-common-position" :title="title"></class-title>
        <div class="its-subTitle">{{desc}}</div>
        <div class="its-details" ref="itsDetails">
          <experience-videos ref="experienceVideos" :height="height" :tab-item="item.item" :father-action="videoChange" @fullScreen="fullScreen"></experience-videos>
        </div>
     </div>
     <div class="its-bg its-bg-1"></div>
     <div class="its-bg its-bg-2"></div>
     <div class="its-bg its-bg-3"></div>
     <div class="its-bg its-bg-4"></div>
   </div>
</template>
<script>
import ClassTitle from '../../home/components/ClassTitle'
import ExperienceVideos from './ExperienceVideos'
export default {
  name: 'ExperienceTabItemTemplate',
  components: {
    ClassTitle,
    ExperienceVideos
  },
  props: {
     item:  {
        type: Object,
        default: function () {
           return {}
        }
     }
  },
  data () {
    return {
      height: '0px',
      title:'',
      desc: ''
    }
  },
  mounted () {
    this.$nextTick(()=>{
      this.height = this.$refs.itsDetails.offsetHeight + 'px'
    })
    this.title = this.item.item.videos[0].title
    this.desc = this.item.item.videos[0].desc
  },
  methods: {
     videoChange: function (data) {
       let type = data.type
       if (type === 'change') {
         this.title = this.item.item.videos[data.index].title
         this.desc = this.item.item.videos[data.index].desc
       }
     },
     stopVideo: function () {
       this.$refs.experienceVideos.stopVideo()
     },
     fullScreen: function (isFullScreen) {
       this.$emit('fullScreen', isFullScreen)
     }
  }
}
</script>

<style scoped>
.its-product-advantage {
  background: white;
}
.its-common-position {
  position: relative;
  z-index: 1;
}
.its-common-position >>> .its-title {
  margin-top: 0;
  padding-top: 0;
}
.its-subTitle {
  font-size: 16px;
  line-height: 1.1;
  color: #3F466A;
  text-align: center;
  font-weight: 300;
  margin-top: 34px;
}
.its-details {
  text-align: center;
  margin-top: 50px;
  height: calc(100vh - 380px);
}
.its-img {
  width: 284px;
  height: 364px;
  margin: 0 41px;
}
.its-calc-container {
  display: table-cell;
  vertical-align: middle;
  width: 100vw;
}
.light {
  background-color: #F6F9FE;
}
.light .its-bg {
  position: absolute;
  z-index: 1;
}
.light .its-bg-1 {
  background-image: url(../../../../../public/images/experience_tab_bg_1.png);
  background-size: 247px 352px;
  width: 247px;
  height: 352px;
  left: 0;
  top: -97px;
}
.light .its-bg-2 {
  background-image: url(../../../../../public/images/experience_tab_bg_2.png);
  background-size: 380px 804px;
  width: 380px;
  height: 804px;
  left: 150px;
  bottom: 52px;
}
.light .its-bg-3 {
  background-image: url(../../../../../public/images/experience_tab_bg_3.png);
  background-size: 160px 160px;
  width: 160px;
  height: 160px;
  right: 28px;
  top: 132px;
}
.light .its-bg-4 {
  background-image: url(../../../../../public/images/experience_tab_bg_4.png);
  background-size: 79px 240px;
  width: 79px;
  height: 240px;
  bottom: 205px;
  right: 205px;
}
</style>